import {
    get, ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { AutoCompleteAddressModel } from "@store/Store/Pages/CheckoutShipping/Handlers/AddressAutocomplete";

const SmartyStreetAutocompleteUrl = "/api/v1/poolcorp/addressValidation/autocomplete";
const SmartyStreetInternationalSummaryAutocompleteUrl = "/api/v1/poolcorp/addressValidation/internationalSummaryAutocomplete";
const SmartyStreetInternationalAutocompleteUrl = "/api/v1/poolcorp/addressValidation/internationalAutocomplete";

export interface AddressCollectionModel {
    addresses: AddressModel[] | undefined;
}

export type AddressModel = {
    name?: string;
    address1?: string;
    address2?: string;
    address3?: string;
    address4?: string;
    attention?: string;
    city?: string;
    companyName?: string;
    contactFullName?: string;
    countryCode?: string;
    email?: string;
    fax?: string;
    firstName?: string;
    fullAddress?: string;
    id?: string;
    label?: string;
    lastName?: string;
    phone?: string;
    postalCode?: string;
    stateCode?: string;
    addressId?: string;
    entries?: number;
}

export interface AddressSummaryCollectionModel {
    addresses: AddressSummaryModel[] | undefined;
}

export type AddressSummaryModel = {
    addressText?: string;
    addressId?: string;
    entries?: number;
    countryCode?: string
}

export async function getAutocompleteShipTos(parameter: AutoCompleteAddressModel): Promise<ServiceResult<AddressCollectionModel>> {
    try {
        const autocompleteShipTos = await get<AddressCollectionModel>(SmartyStreetAutocompleteUrl, undefined, { searchTerm: parameter.searchTerm });
        if (autocompleteShipTos && autocompleteShipTos.addresses) {
            autocompleteShipTos.addresses = autocompleteShipTos.addresses.map(address => ({
                ...address,
                countryCode: parameter.country,
            }));
        }

        return {
            successful: true,
            result: autocompleteShipTos,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "An error has occurred",
        };
    }
}

export async function getInternationalAutocompleteSummaryShipTos(parameter: AutoCompleteAddressModel): Promise<ServiceResult<AddressSummaryCollectionModel>> {
    try {
        let autocompleteSummaries;
        if (parameter.addressId === undefined) {
            autocompleteSummaries = await get<AddressSummaryCollectionModel>(SmartyStreetInternationalSummaryAutocompleteUrl, undefined, { searchTerm: parameter.searchTerm, country: parameter.country });
        } else {
            autocompleteSummaries = await get<AddressSummaryCollectionModel>(SmartyStreetInternationalSummaryAutocompleteUrl, undefined, { addressId: parameter.addressId, country: parameter.country });
        }
        const country = parameter.country;
        const mappedAddresses = autocompleteSummaries.addresses?.map(summary => summaryToAddress(summary, country)) || [];

        return {
            successful: true,
            result: { addresses: mappedAddresses },
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "An error has occured",
        };
    }
}

export async function getInternationalAutocompleteShipTos(parameter: AutoCompleteAddressModel): Promise<ServiceResult<AddressCollectionModel>> {
    try {
        const autocompleteShipTo = await get<AddressCollectionModel>(SmartyStreetInternationalAutocompleteUrl, undefined, { addressId: parameter.addressId, country: parameter.country });
        return {
            successful: true,
            result: autocompleteShipTo,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: "An error has occured",
        };
    }
}
function summaryToAddress(summary: AddressSummaryModel, country: string): AddressModel {
    return {
        address1: summary.addressText,
        addressId: summary.addressId,
        entries: summary.entries,
        countryCode: country,
        fullAddress: summary.addressText
    };
}